import React from "react";
import { Copy } from "lucide-react";
import { copyText } from "../../lib/clipboard";

const GRID = "grid grid-cols-[52px_minmax(0,1fr)_minmax(0,1.4fr)] gap-2 items-center";

const CopyCell = ({ value, testid }) => (
  <button type="button" onClick={() => copyText(value, "Copied")} data-testid={testid} title={value}
    className="group flex items-center gap-1.5 min-w-0 text-left font-mono text-xs text-slate-700 hover:text-sky-700 transition-colors">
    <span className="break-all">{value}</span>
    <Copy size={11} className="shrink-0 text-slate-300 group-hover:text-sky-500" />
  </button>
);

export const DomainRecords = ({ records }) => (
  <div className="rounded-xl border border-slate-200 bg-white overflow-hidden" data-testid="domain-records">
    <div className={`${GRID} px-3 py-2 bg-slate-50 text-[10px] uppercase tracking-wider text-slate-400 font-mono`}>
      <span>Type</span><span>Name / Host</span><span>Value</span>
    </div>
    {records.map((r, i) => (
      <div key={`${r.type}-${r.host}-${r.value}`} className={`${GRID} px-3 py-2.5 border-t border-slate-100`} data-testid={`domain-record-${i}`}>
        <span className="px-1.5 py-0.5 rounded-md bg-sky-50 text-sky-700 text-[11px] font-mono font-semibold text-center">{r.type}</span>
        <CopyCell value={r.host} testid={`domain-record-host-${i}`} />
        <div className="min-w-0">
          <CopyCell value={r.value} testid={`domain-record-value-${i}`} />
          {r.optional && <span className="text-[10px] text-slate-400">optional — makes www work too</span>}
        </div>
      </div>
    ))}
  </div>
);

export default DomainRecords;
